const Auth = {
    createAccountInvitation: "createAccount.invitation",
};

export default Auth;
